module.exports = __webpack_public_path__ + "static/media/logo-publipostage.7d95f97c.svg";